export default __webpack_public_path__ + "static/painting2-266aa08f32cfa19b9bce1d16e1ed22eb.jpg";